import React from 'react';
import { SvgIconProps } from './types';

const sizeMap = {
    small: '20px',
    medium: '24px',
    large: '32px',
    inherit: 'inherit',
};

const FrejaeidIcon = ({
    size,
    fontSize = 'medium',
    className,
    style,
    role,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden,
}: SvgIconProps) => {
    const iconSize = size || sizeMap[fontSize];
    return (
        // This icon is an <img>, not an <svg>, so the accessibility props
        // `Icon` passes through have to be applied by hand rather than
        // spread onto an SvgIcon. `alt` is the img equivalent of the
        // `aria-label` the other icons get, so it carries the label when
        // there is one and falls back to the brand name.
        <img
            src="https://www.joinflow.com/appdirectory/freja_icon.png"
            alt={ariaLabel ?? 'Freja eID'}
            role={role}
            aria-hidden={ariaHidden}
            className={className}
            style={{ width: iconSize, height: iconSize, ...style }}
        />
    );
};

export default FrejaeidIcon;
